import "../../chunk-D57E6H3M.mjs";

// src/domain/chat/utils.ts
import { ChatStreamStatus } from "./types.mjs";
function formatToolName(toolName) {
  return toolName.replace(/([A-Z])/g, " $1").replace(/^./, (str) => str.toUpperCase()).trim();
}
function isStreamLive(status) {
  return status === ChatStreamStatus.InProgress || status === ChatStreamStatus.Waiting;
}
export {
  formatToolName,
  isStreamLive
};
//# sourceMappingURL=utils.mjs.map